import i18nFactory from '@yandex-int/i18n';

import { Tld } from '../../../typings/common';
import {
    Bundle,
    CommonCreativeApiResponse,
    CommonCreativeBaseApiItem,
    CommonCreativeIdeaApiResponse,
    CommonCreativePresetApiResponse,
    DisclaimersApiResponse
} from '../../common/requestsTypings';
import { CommonOptionGroupName, CreativeOptionsData } from '../../CreativeOptions/typings';
import {
    mapCommonCreativeItemFromApi,
    mapCommonCreativeItemFromIdeaApi,
    mapCommonCreativeItemFromPresetApi,
    mapOptionsValueFromApi
} from '../AddCommonCreative/mappers';
import { getAdaptiveConfig } from '../CreativeConfigHelper/CreativeConfigHelper';
import { CommonCreativeItem } from '../typings';

// tslint:disable-next-line no-external-i18n-import
import * as keyset from './AddAdaptiveCreative.i18n';
import { HIDDEN_PRESET_PARAMETERES } from './helpers';

const i18n = i18nFactory(keyset);

const mapAdaptiveCreativeOptionsFromApi = (data: {
    item: CommonCreativeBaseApiItem;
    id: string;
    name: string;
    disclaimers: DisclaimersApiResponse;
    tld: Tld;
    hiddenGroups?: CommonOptionGroupName[];
    commonOptionsAvailable?: boolean;
}): CreativeOptionsData => {
    const {
        item: { elements, options, mediaSets },
        id,
        name,
        disclaimers,
        tld,
        hiddenGroups,
        commonOptionsAvailable
    } = data;
    const optionsConfig = getAdaptiveConfig(id, disclaimers, tld);
    return {
        name,
        optionsConfig,
        optionsValue: mapOptionsValueFromApi({
            values: elements,
            config: optionsConfig,
            commonOptions: options,
            mediaSets,
            hiddenGroups,
            commonOptionsAvailable
        })
    };
};

export const mapAdaptiveCreativeFromPresetApi = (
    response: CommonCreativePresetApiResponse,
    disclaimers: DisclaimersApiResponse,
    tld: Tld,
    commonOptionsAvailable?: boolean
): {
    options: CreativeOptionsData;
    item: CommonCreativeItem;
    bundle: Bundle;
} => {
    // для адаптивного креатива приходит 1 item
    const item = response.items[0];

    return {
        options: mapAdaptiveCreativeOptionsFromApi({
            item,
            id: String(response.id),
            name: i18n('default-name'),
            disclaimers,
            tld,
            hiddenGroups: HIDDEN_PRESET_PARAMETERES,
            commonOptionsAvailable
        }),
        item: mapCommonCreativeItemFromPresetApi(item),
        bundle: item.bundle
    };
};

export const mapAdaptiveCreativeFromApi = (
    response: CommonCreativeApiResponse,
    disclaimers: DisclaimersApiResponse,
    tld: Tld,
    commonOptionsAvailable?: boolean
): {
    options: CreativeOptionsData;
    item: CommonCreativeItem;
    bundle: Bundle;
    presetId?: string;
    batchId?: string;
} => {
    // для адаптивного креатива приходит 1 item
    const item = response.items[0];

    return {
        options: mapAdaptiveCreativeOptionsFromApi({
            item: item.data,
            id: response.id,
            name: response.name,
            disclaimers,
            tld,
            commonOptionsAvailable
        }),
        item: mapCommonCreativeItemFromApi(item),
        bundle: item.data.bundle,
        // Для некоторых креативов в запросе получения информации о них нет presetId,
        // необходимого для запроса создания. Для таких креативов есть batchId, который необходимо
        // сохранять и передавать затем в запросе создания
        presetId: item.presetId !== undefined ? String(item.presetId) : undefined,
        batchId: item.batchId
    };
};

export const mapAdaptiveCreativeFromIdeaApi = (
    response: CommonCreativeIdeaApiResponse,
    disclaimers: DisclaimersApiResponse,
    tld: Tld,
    commonOptionsAvailable?: boolean
): {
    options: CreativeOptionsData;
    item: CommonCreativeItem;
    bundle: Bundle;
    isIdea: true;
} => {
    // для адаптивного креатива приходит 1 item
    const item = response.items[0];

    return {
        options: mapAdaptiveCreativeOptionsFromApi({
            item: item.data,
            id: response.ideaId,
            name: i18n('default-name'),
            disclaimers,
            tld,
            commonOptionsAvailable
        }),
        item: mapCommonCreativeItemFromIdeaApi(item),
        bundle: item.data.bundle,
        isIdea: true
    };
};
